// extracted by mini-css-extract-plugin
module.exports = {"inputCode":"PaymentsPromoCodeRedeemForm__inputCode"};